<template>
  <div class="mymapM">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">选择地址</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 搜索 -->
    <div class="search_address">
      <div class="search_addressinput">
        <img class="searchaddress_icon" src="/static/sousuoicon.png" />
        <input @input="keySearch()" class="searchaddress_input" placeholder="输入关键字搜索" v-model="search_key" />
        <!-- <span class="clear" v-if="search_key" @click="search_key = ''"></span> -->
      </div>
      <div class="search_sousuo" @click="keySearch()">搜索</div>
    </div>

    <div class="con_box">
      <!-- 地图 -->
      <div class="map_box">
        <div class="map" id="container" style="width:100%;height:300px;"></div>
        <img class="sign" src="/static/dingwei.png" />
      </div>
      <!-- 地址列表 -->
      <div class="maplist_box">
        <div class="maplist_box_box" v-for="(item,index) in lists" @click="onResLi(item)">
          <div class="mapaddress_name">{{item.name}}</div>
          <div class="mapaddress_detail">{{item.address}}</div>
        </div>
      </div>
    </div>
    <!-- 搜索列表 -->
    <div class="search_list" v-if="!!search_key">
      <div class="maplist_box_box1" v-for="(item, index) in search_list" :key="index" @click="onSearchLi(item.location)">
        <div class="mapaddress_name">{{item.name}}</div>
        <div class="mapaddress_detail">{{item.address}}</div>
      </div>
      <div class="nosearchShow" v-if="noSearchShow">暂无搜索结果</div>
    </div>
  </div>
</template>
<script>
  // import AMap from 'AMap'
  import httper from "../../api/http";
  export default {
    data() {
      return {
        //center: [113.364281, 22.492371], //纬度-经度113.3926, 22.51595 113.34565,22.45873 22.492371,113.364281
        center: [],
        search_key: '', //搜索值113.36455,22.49226
        lists: [], //地点列表
        search_list: [], //搜索结果列表
        noSearchShow: false, //无搜索结果提示，无搜索结果时会显示暂无搜索结果
        latitude: "", // 微信api获取用户当前纬度,默认为空22.51595
        longitude: "", // 微信api获取用户当前经度,默认为空113.3926
        product_id: "",
        name: "", //联系人
        phone: "", //联系人电话
        licenseItem: {},
        address: {},
        date: "",
        time: "",
        isAppointment: false,
        items: "", //返回哪个页面
        store_id: '',
        product_name: "",
        product_type: "",
        city: "",
        address11: "", //上页面传来联系人详细地址
        serviceList: [], //店铺信息 服务列表
        servicePricelist: [], //店铺信息 服务价格
        password: "", //店铺信息 密码
        contactName: "", //联系人
        logoimg: "", //店铺logo
      };
    },
    created() {
      // this.getwechat({
      //   url: location.href.split('#')[0]
      // })
      // if (sessionStorage.getItem("latitude")) {
      //   this.latitude = sessionStorage.getItem("latitude")
      // }
      // if (sessionStorage.getItem("longitude")) {
      //   this.longitude = sessionStorage.getItem("longitude")
      // }
      // if (!sessionStorage.getItem("latitude") || !sessionStorage.getItem("longitude")) {

      //   this.getWxLocation()
      // } else {
      //   this.center = [sessionStorage.getItem("longitude"), sessionStorage.getItem("latitude")]
      // }
      //this.getWxLocation()
      this.getlocation1()
      if (this.$route.query.product_id) {
        this.product_id = Number(this.$route.query.product_id);
      } else {
        this.product_id = "";
      }
      if (this.$route.query.licenseItem) {
        this.licenseItem = this.$route.query.licenseItem
      } else {
        this.licenseItem = "";
      }
      if (this.$route.query.name) {
        this.name = this.$route.query.name;
      } else {
        this.name = "";
      }
      if (this.$route.query.contactName) {
        this.contactName = this.$route.query.contactName;
      } else {
        this.contactName = "";
      }
      if (this.$route.query.logoimg) {
        this.logoimg = this.$route.query.logoimg;
      } else {
        this.logoimg = "";
      }
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      } else {
        this.phone = "";
      }
      if (this.$route.query.password) {
        this.password = this.$route.query.password;
      } else {
        this.password = "";
      }
      if (this.$route.query.serviceList) {
        this.serviceList = this.$route.query.serviceList;
      } else {
        this.serviceList = [];
      }
      if (this.$route.query.servicePricelist) {
        this.servicePricelist = this.$route.query.servicePricelist;
      } else {
        this.servicePricelist = [];
      }
      if (this.$route.query.date) {
        this.date = this.$route.query.date;
      } else {
        this.date = "";
      }
      if (this.$route.query.time) {
        this.time = this.$route.query.time;
      } else {
        this.time = "";
      }
      if (this.$route.query.isAppointment) {
        this.isAppointment = this.$route.query.isAppointment;
      } else {
        this.isAppointment = false;
      }
      if (this.$route.query.items) {
        this.items = this.$route.query.items;
      } else {
        this.items = "";
      }
      if (this.$route.query.store_id) {
        this.store_id = this.$route.query.store_id;
      } else {
        this.store_id = '';
      }
      if (this.$route.query.product_name) {
        this.product_name = this.$route.query.product_name;
      } else {
        this.product_name = "";
      }
      //上页面获取商品服务类型
      if (this.$route.query.product_type) {
        this.product_type = this.$route.query.product_type;
      } else {
        this.product_type = "";
      }

      if (this.$route.query.city) {
        this.city = this.$route.query.city
      } else {
        this.city = "";
      }
      if (this.$route.query.address11) {
        this.address11 = this.$route.query.address11
      }
    },
    mounted() {


      // this.adMap()
    },
    watch: {
      search_key(newv, oldv) {
        if (newv == '') {
          this.search_list = [];
          this.noSearchShow = false;
        }
      }
    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      getlocation1() {
        //获取定位
        let mapObj = new AMap.Map('iCenter', {
          resizeEnable: true
        });
        //添加AMap.Geolocation插件
        AMap.plugin('AMap.Geolocation', function() {
          //使用插件以及插件的配置
          var geolocation = new AMap.Geolocation({

            enableHighAccuracy: true,// 是否使用高精度定位，默认：true
            timeout: 10000,// 设置定位超时时间，默认：无穷大
            maximumAge: 0, //定位结果缓存0毫秒，默认：0
            convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true, //显示定位按钮，默认：true
            buttonOffset: new AMap.Pixel(10, 20),// 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
            zoomToAccuracy: true,//  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            buttonPosition: 'LB',//  定位按钮的排放位置,  RB表示右下
            GeoLocationFirst:true,//默认为false，设置为true的时候可以调整PC端为优先使用浏览器定位，失败后使用IP定位
            showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          });
          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, 'complete', onComplete)
          AMap.event.addListener(geolocation, 'error', onError)

          function onComplete(data) {
            // data是具体的定位信息
            console.log(data)
          }

          function onError(data) {
            // 定位出错
            console.log(data)
            console.log("11111")
            getLngLatLocation()
          }
          const self = this;

          function getLngLatLocation() {

            AMap.plugin("AMap.CitySearch", function() {
              var citySearch = new AMap.CitySearch();
              console.log("citySearch",citySearch)
              citySearch.getLocalCity(function(status, result) {
                console.log("status",status)
                console.log("result",result)
                if (status === "complete" && result.info === "OK") {
                  // 查询成功，result即为当前所在城市信息
                  console.log(result);
                  AMap.plugin("AMap.Geocoder", function() {
                    var geocoder = new AMap.Geocoder({
                      // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                      city: result.adcode
                    });
                    var lnglat = result.rectangle.split(";")[0].split(",");
                    geocoder.getAddress(lnglat, function(status, data) {
                      if (status === "complete" && data.info === "OK") {
                        // result为对应的地理位置详细信息
                        // var getLongitude = opis.position.getLng();
                        // var getLatitude = opis.position.getLat();
                        // that.center = [getLongitude, getLatitude]
                        // that.adMap()
                        console.log(status, result, data);
                      }
                    });
                  });
                }else {
                  console.log("tip",result.info)
            }
              });
            });
          }
        });
      },
      //高德定位
      getlocation() {
        let that = this
        var mapObj = new AMap.Map('iCenter');
        mapObj.plugin('AMap.Geolocation', function() {
          var geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
            maximumAge: 0, //定位结果缓存0毫秒，默认：0
            convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
            showButton: true, //显示定位按钮，默认：true
            buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
            buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
            showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
            panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
            zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          });
          console.log("高德定位", geolocation.getCurrentPosition())
          mapObj.addControl(geolocation);
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', function onComplete(opis) {
            console.log("定位信息", opis)
            var getLongitude = opis.position.getLng();
            var getLatitude = opis.position.getLat();
            that.center = [getLongitude, getLatitude]
            that.adMap()
          }); //返回定位信息
          AMap.event.addListener(geolocation, 'error', function onError(error) {
            console.log("that.center.length==0", that.center.length == 0)
            if (that.center.length == 0) {
              that.center = [113.392517, 22.517024]
            }
            that.adMap()
            console.log("错误信息", error)
          }); //返回定位出错信息

        });

      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        console.log('getwechat 1')
        httper.get("wechat/wechat/sign-package", requestData, res => {
          //wx.ready(() => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
          });
        })

        //});
      },
      getWxLocation() {
        let that = this
        wx.ready(() => {
          console.log('wx ready', "yes")
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function(res) {
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
              that.latitude = latitude;
              that.longitude = longitude;
              that.center = [that.longitude, that.latitude]
              that.adMap()
            },
            complete(ree) {
              if (that.center.length == 0) {
                that.center = [113.392517, 22.517024]
              }
              that.adMap()
            }

          });
        });
      },
      // onComplete(opis) {
      // },
      // onError(error) {
      // },
      adMap() {
        let that = this
        //初始化地图
        var map = new AMap.Map('container', {
          zoom: 14, //缩放级别
          center: that.center, //设置地图中心点
          // resizeEnable: true, //地图初始化加载定位到当前城市
        });
        //获取初始中心点并赋值
        var currentCenter = map.getCenter(); //此方法是获取当前地图的中心点
        this.center = [currentCenter.lng, currentCenter.lat]; //将获取到的中心点的纬度经度赋值给data的center
        //根据地图中心点查附近地点，此方法在下方
        this.centerSearch();
        //监听地图移动事件，并在移动结束后获取地图中心点并更新地点列表
        var moveendFun = (e) => {
          // 获取地图中心点
          currentCenter = map.getCenter();
          this.center = [currentCenter.lng, currentCenter.lat]
          //根据地图中心点查附近地点
          this.centerSearch();
        }
        // 绑定事件移动地图事件
        map.on('moveend', moveendFun);
      },
      centerSearch() {
        let that = this
        AMap.service(["AMap.PlaceSearch"], () => {
          //构造地点查询类
          var placeSearch = new AMap.PlaceSearch({
            //type: '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', // 兴趣点类别
            type: '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施',
            pageSize: 30, // 单页显示结果条数
            pageIndex: 1, // 页码
            city: "全国", // 兴趣点城市that.city ? that.city :
            autoFitView: false, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            extensions: "all"
          });
          //根据地图中心点查附近地点
          placeSearch.searchNearBy(that.search_key, [this.center[0], this.center[1]], 200, (status, result) => {
            if (status == 'complete') {
              this.lists = result.poiList.pois //将查询到的地点赋值
            }
          });
        });
        // AMap.plugin(["AMap.Autocomplete"], () => {
        //   var autoOptions = {
        //     city: '全国'
        //   }
        //   var autoComplete = new AMap.Autocomplete(autoOptions);
        //   autoComplete.search(that.search_key, function(status, result) {
        //     // 搜索成功时，result即是对应的匹配数据
        //   })
        // })
      },
      keySearch() {
        let that = this
        // AMap.plugin(["AMap.Autocomplete"], () => {
        //   //构造地点查询类
        //   var autoOptions = new AMap.Autocomplete({
        //     type: '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', // 兴趣点类别
        //     pageSize: 30, // 单页显示结果条数
        //     pageIndex: 1, // 页码
        //     city: "全国", // 兴趣点城市
        //     citylimit: false, //是否强制限制在设置的城市内搜索
        //     autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        //   });
        //   //关键字查询
        //   autoOptions.search(that.search_key, (status, result) => {
        //     if (status == 'complete') {
        //       if (result.count === 0) {
        //         that.noSearchShow = true;
        //       } else {
        //         that.search_list = result.tips //将查询到的地点赋值
        //         that.noSearchShow = false;
        //       }
        //     } else {
        //       that.search_list = [];
        //       that.noSearchShow = true;
        //     }
        //   });

        // });
        AMap.service(["AMap.PlaceSearch"], () => {
          //构造地点查询类
          var placeSearch = new AMap.PlaceSearch({
            //type: '汽车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|地名地址信息', // 兴趣点类别
            type: '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施',
            pageSize: 30, // 单页显示结果条数
            pageIndex: 1, // 页码
            city: "全国", // 兴趣点城市that.city ? that.city :
            citylimit: false, //是否强制限制在设置的城市内搜索
            autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          });
          //关键字查询
          placeSearch.search(that.search_key, (status, result) => {

            if (status == 'complete') {

              if (result.poiList.count === 0) {
                that.noSearchShow = true;
              } else {
                that.search_list = result.poiList.pois //将查询到的地点赋值

                that.noSearchShow = false;
              }
            } else {
              that.search_list = [];
              that.noSearchShow = true;
            }
          });

        });
      },
      onSearchLi(e) {
        this.lists = e
        this.center = [e.lng, e.lat];
        this.adMap();
        this.search_key = '';
      },
      onResLi(e) {
        switch (this.items) {
          //
          case 'appointmentYearInsp':
            this.$router.push({
              path: "/appointmentYearInsp",
              query: {
                address: e,
                product_id: this.product_id,
                name: this.name, //联系人
                phone: this.phone, //联系人电话
                licenseItem: this.licenseItem,
                date: this.date,
                time: this.time,
                store_id: this.store_id,
                product_name: this.product_name,
                product_type: this.product_type,
                city: this.city
              }
            })
            break
            //代驾年审
          case 'yearlyInspection':
            this.$router.push({
              path: "/yearlyInspection",
              query: {
                address: JSON.stringify(e),
                product_id: this.product_id,
                name: this.name, //联系人
                phone: this.phone, //联系人电话
                licenseItem: this.licenseItem,
                date: this.date,
                time: this.time,
                address11: this.address11,
                store_id: this.store_id,
                product_name: this.product_name,
                product_type: this.product_type,
                city: this.city
              }
            })
            break
            //店铺服务
          case 'storeService':
            this.$router.push({
              path: "/storeService",
              query: {
                address: JSON.stringify(e),
                name: this.name, //联系人
                phone: this.phone, //联系人电话
                contactName: this.contactName, //联系人
                logoimg: this.logoimg, //店铺logo
                password: this.password,
                serviceList: this.serviceList,
                servicePricelist: this.servicePricelist,
              }
            })
            break
        }
        // if (this.isAppointment) {
        //   this.$router.push({
        //     path: "/appointmentYearInsp",
        //     query: {
        //       address: e,
        //       product_id: this.product_id,
        //       name: this.name, //联系人
        //       phone: this.phone, //联系人电话
        //       licenseItem: this.licenseItem,
        //       date: this.date,
        //       time: this.time,
        //       store_id: this.store_id,
        //       product_name: this.product_name,
        //       product_type: this.product_type,
        //       city: this.city
        //     }
        //   })
        // } else {
        //   this.$router.push({
        //     path: "/yearlyInspection",
        //     query: {
        //       address: JSON.stringify(e),
        //       product_id: this.product_id,
        //       name: this.name, //联系人
        //       phone: this.phone, //联系人电话
        //       licenseItem: this.licenseItem,
        //       date: this.date,
        //       time: this.time,
        //       address11: this.address11,
        //       store_id: this.store_id,
        //       product_name: this.product_name,
        //       product_type: this.product_type,
        //       city: this.city
        //     }
        //   })
        // }
      },
    }
  }
</script>
<style scoped>
  .search_address {
    width: 100%;
    height: 55px;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #EEEEEE;
    display: flex;
    align-items: center;
  }

  .search_addressinput {
    width: 88%;
    height: 100%;
    border-radius: 8px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .searchaddress_icon {
    width: 17px;
    height: 17px;
    margin-right: 5px;
  }

  .searchaddress_input {
    width: 100%;
  }

  input {
    border: none;
    outline: none;
    /*    width: 100%; */
  }

  input::-webkit-input-placeholder {
    font-size: 12px;
    color: #BCBCBC;
  }

  .search_sousuo {
    font-size: 14px;
    margin-left: 10px;
  }

  .con_box {
    width: 100%;
    height: 100%;
  }

  .map_box {
    width: 100%;
    height: 50%;
    position: relative;
  }

  .map {
    width: 100%;
    height: 100%;
  }

  .sign {
    /*  width: 30px;
    height: 30px;
    position: absolute;
    margin: auto;
    top: -15px; */

    width: 7%;
    height: 10%;
    position: absolute;
    margin: auto;
    top: 40%;
    left: 46%;
    /* bottom: auto;
    left: auto;
    right: auto; */
  }

  .maplist_box {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
  }

  .maplist_box_box1 {
    width: 100%;
    border-bottom: 1px solid #D2D2D2;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .maplist_box_box {
    width: 100%;
    border-bottom: 1px solid #D2D2D2;
    padding: 5px 0;
    box-sizing: border-box;
  }

  .mapaddress_name {
    font-size: 16px;
  }

  .mapaddress_detail {
    font-size: 14px;
    color: #666666;
  }

  .search_list {
    width: 100%;
    /* padding: 10px 20px; */
    box-sizing: border-box;
    position: absolute;
    z-index: 9999;
    top: 105px;
    background-color: #FFFFFF;
  }

  .nosearchShow {
    font-size: 14px;
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/chooseLocation.vue